import IState from 'services/state';

export const getIsLoadingChargeTip = (state: IState) => state.tipping.loadingChargeTip;
export const getIsSuccessChargeTip = (state: IState) => state.tipping.successChargeTip;
export const getIsUsingPaymentRequestButtonForm = (state: IState) => state.tipping.usingPaymentRequestButtonForm;
export const getTipSuggestedAmounts = (state: IState) => state.tipping.tipSuggestedAmounts;
export const getTipAmount = (state: IState) => state.tipping.amount;
export const getTipMessage = (state: IState) => state.tipping.message;
export const getIdempotencyKey = (state: IState) => state.tipping.idempotencyKey;
